import React from "react";
import classnames from "classnames";
import map from "lodash/map";
import { constToCSS } from "../reducers/download";
import { ToastTypes } from "../constants/toastTypes";
import { connect } from "react-redux";
import * as actions from "../actions/actions";

class Toasts extends React.Component {
    constructor(props) {
        super(props);
        this.handleDismiss = this.handleDismiss.bind(this);
    }

    handleDismiss(bannerType, msg) {
        this.props.bannerDismiss(bannerType);
    }

    render() {
        let { result, toastTypes } = this.props;

        let toasts = map(this.props.all, (toast, key) => {
            if (!toast || !key) return null;
            let Component = toastTypes[key];

            if (!Component) {
                console.warn(`Toast component ${Component} not found`);
                return null;
            }
            let childProps = {};
            childProps.bannerDismiss = this.handleDismiss.bind(this, key);
            let dismiss = (
                <div
                    onClick={childProps.bannerDismiss}
                    title="close"
                    className="close ui_close"
                />
            );

            let modalClasses = classnames(
                "toast-container",
                `${constToCSS(key)}-toast-container`
            );

            return (
                <div className={modalClasses} key={key}>
                    <div className="toast-content">
                        {dismiss}
                        <Component {...childProps} result={result} />
                    </div>
                </div>
            );
        });
        return <div>{toasts}</div>;
    }
}

function mapStateToProps(state, ownProps) {
    let all = state.banners.toasts;

    let toastTypes = {
        ...ToastTypes,
        ...ownProps.toastTypes
    };

    return {
        all,
        toastTypes
    };
}

export default connect(mapStateToProps, {
    bannerDismiss: actions.bannerDismiss
})(Toasts);
